export const Tradeshow_Attendance_Type = [
  { id: 1, description: 'None' },
  { id: 2, description: 'Customer attendant In-Person' },
  { id: 3, description: 'Promo only' },
];
export const Verified_Referral = [
  { id: 1, description: 'None' },
  { id: 2, description: 'Yes' },
  { id: 3, description: 'No' },
];
export const Lea_Type = [
  { id: 1, description: '-- None --' },
  { id: 2, description: 'Hydrafacial Deivce' },
  { id: 3, description: 'SkinStylus' },
  { id: 4, description: 'HydraFacial and SkinStylus' },
];
export enum UserStatusEnum {
  active = 1,

  disabled = 2,

  approval_pending = 3
}

export enum ProspectStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2
}
export enum CreditCardType {
  Visa = 'Visa',
  Mastercard = 'Mastercard',
  Amex = 'Amex',
  Discover = 'Discover',
  JCB = 'JCB',
  DinersClub = 'DinersClub',
  UnionPay = 'UnionPay'
}

export const CreditCardTypeLabels: { [key in CreditCardType]: string } = {
  [CreditCardType.Visa]: 'Visa',
  [CreditCardType.Mastercard]: 'Mastercard',
  [CreditCardType.Amex]: 'American Express',
  [CreditCardType.Discover]: 'Discover',
  [CreditCardType.JCB]: 'JCB',
  [CreditCardType.DinersClub]: 'Diners Club',
  [CreditCardType.UnionPay]: 'UnionPay'
};


export interface CustomField {
  id: number;
  name: string;
  minLength: number;
  maxLength: number;
  helpText: string;
  isRequired: boolean;
  isUnique: boolean;
  defaultValue: string | null;
  fieldType: number;
  moduleType: number;
  customFieldsData_sid: any;
  data: any;
  moduleId: number;
}
export enum FieldType {
  Text = 1,
  Number = 2,
  Date = 3,
  Checkbox = 4,
  Phone = 5,
  Email = 6,
  Url = 7
}
export enum AddressType {
  ShippingAddress = 1,
  MailingAddress = 2
}
export enum UserPermissions {


  USER_VIEW = 'USER_VIEW',
  USER_CREATE = 'USER_CREATE',
  USER_UPDATE = 'USER_UPDATE',

ViewHomeMenu = 'ViewHomeMenu',

ViewAuditLog = 'ViewAuditLog',
  DASHBOARD = 'DASHBOARD',
// Point Of Sale Module Permissions
ViewPOSMenu='ViewPOSMenu',
ViewExpenseMenu='ViewExpenseMenu',
ViewHistoryMenu='ViewHistoryMenu',
ViewAllStockMenu='ViewAllStockMenu',
ViewAccountingMenu='ViewAccountingMenu',
ViewMasterCategoriesMenu='ViewMasterCategoriesMenu',
ViewPurchaseOrderMenu='ViewPurchaseOrderMenu',
ViewReturnOrderMenu='ViewReturnOrderMenu',
ViewSettingMenu='ViewSettingMenu',
ViewReportsMenu='ViewReportsMenu',


ViewUsersMenu = 'ViewUsersMenu',
ViewRolesMenu = 'ViewRolesMenu',
ViewPermissionsMenu = 'ViewPermissionsMenu',


}
export enum RolesEnum {
  Officer = 'Officer',
  DepartmentSupervisor = 'DepartmentSupervisor',
  DepartmentManager = 'DepartmentManager',
  Admin = 'ADMIN',
  L2Support = 'L2Support',
  Technician = 'Technician',
  Analyst = 'Analyst',
  Customer= 'Customer'
  
}
export enum DocumentTypeenum {
  ServiceCategory = 'ServiceCategory',
  Service = 'Service',
  CompanyInvoiceLogo = 'InvoiceLogo',
  CompanyLogo = 'CompanyLogo',
  CustomerDocuments = 'CustomerDocuments',
  WorkOrderDocuments = 'WorkOrderDocuments',
  InvoiceDocuments = 'InvoiceDocuments',
  VendorDocuments = 'VendorDocuments',
  Employee = 'Employee',
  EmployeeProfilePicture = 'EmployeeProfilePicture',
  PayableDetail = 'PayableDetail',
  PurchaseOrderDocuments = 'PurchaseOrderDocuments',
  InvoiceCheckPaymentImage = 'InvoiceCheckPaymentImage',
  InvoiceDocumentsPdf = 'InvoiceDocumentsPdf',
  EquipmentPicture = 'EquipmentPicture',
  CustomerEquipmentPicture = 'CustomerEquipmentPicture'
}

export interface CustomerAddressDto  {
  customerId: number;
  propertyName?: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  address?: string;
  unit?: string;
  city?: string;
  stateId?: number;
  zip?: string;
  emailAddress?: string;
  contactNo?: string;
  notes?: string;
  notifyBySms: boolean;
  notifyByEmail: boolean;
  deleted: boolean;
  state?: string;
}
export enum WorkOrderStatusEnum {
  Rejected = 1,
  Pending = 2,
  Dispatched = 3,
  InProgress = 4,
  Cancelled = 6,
  Completed = 7,
  Pause = 9,
  Holding = 10,
  Estimate = 11,
  CallBack = 12,
  MoneyCall = 13,
  PendCompletion = 14,
}
export enum PaymentMethodEnum {
  
  Cash = 1,
  Check = 2,
  CreditCard = 3,
  Billing = 4,
  Estimate = 5,
}

export function enumToKeyValueStringList<T>(enumObj: T): { label: string; value: any }[] {
  return Object.keys(enumObj)
    .filter(key => isNaN(Number(key))) // Exclude numeric keys
    .map(key => ({
      label: key,
      value: key,
    }));
}

export function enumToKeyValueIntList<T>(enumObj: T): { label: string; value: any }[] {
  return Object.keys(enumObj)
    .filter(key => isNaN(Number(key))) // Exclude numeric keys
    .map(key => ({
      label: key,
      value: enumObj[key as keyof T],
    }));
    
}


export enum TemplateTypeEnum {
  Email = 1,
  Sms = 2,
  PushNotification = 3,
}

export const AccountType = [
  {
    label: "Saving",
    value: "Saving",
  },
  {
    label: "Checking",
    value: "Checking",
  }
];
